import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ColContainer = styled(Col)`
  display: flex;
  flex-direction: column;
  @media ${media.maxWidth.sm} {
    flex-direction: row;
    margin-bottom: ${spacing('lg')};
    margin-top: calc(-1 * ${spacing('lg')});
  }
`;

export const $StepNumber = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-item: center;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
  background: transparent;
  padding: ${spacing('lg')};
  font-weight: 700;
  margin-left: unset;
  margin-right: unset;
  margin-bottom: ${spacing('lg')};

  svg {
    margin-left: ${spacing(2.5)};
    width: 18px;
    height: 18px;
  }

  @media ${media.maxWidth.sm} {
    &:not(:last-child) {
      margin-right: ${spacing('lg')};
    }
  }
`;
